import { apiServer } from "@/globalVars";

// eslint-disable-next-line no-undef
const axios = require("axios").default;

function createAxios(extraHeaders) {
  // return authorization header with jwt token
  const user = JSON.parse(localStorage.getItem("user"));
  const headers = {};
  if (user && user.accessToken) {
    headers.Authorization = `Bearer ${user.accessToken}`;
  }

  if (extraHeaders) {
    for (const [key, value] of Object.entries(extraHeaders)) {
      headers[key] = value;
    }
  }

  if (!("Content-Type" in headers)) {
    headers["Content-Type"] = "application/json";
  }

  const instance = axios.create({
    baseURL: apiServer,
    headers,
  });

  instance.interceptors.response.use(
    (response) => Promise.resolve(response.data),
    (error) => {
      if (error.response) {
        if ([401].includes(error.response.status)) {
          localStorage.removeItem("user");
          // eslint-disable-next-line no-restricted-globals
          location.replace("/authentication/signin");
        } else if ([403].includes(error.response.status)) {
          location.replace("/authentication/error/error403");
        }
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject("Error al acceder a los servicios API");
      }
    }
  );
  return instance;
}

function createPublicAxios() {
  // return authorization header with jwt token
  const headers = {};

  if (!("Content-Type" in headers)) {
    headers["Content-Type"] = "application/json";
  }

  const instance = axios.create({ baseURL: apiServer });

  instance.interceptors.response.use(
    (response) => Promise.resolve(response.data),
    (error) => {
      if (error.response) {
        return Promise.reject(error.response.data);
      } else {
        return Promise.reject("Error al acceder a los servicios API");
      }
    }
  );
  return instance;
}

export default createAxios;
export { createAxios, createPublicAxios };
